import { render, staticRenderFns } from "./VistaPlanes.vue?vue&type=template&id=161daf1e&"
import script from "./VistaPlanes.vue?vue&type=script&lang=ts&"
export * from "./VistaPlanes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports